import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Wind, Menu, X } from 'lucide-react';
import { DesktopNav } from '@/components/navbar/DesktopNav';
import { MobileNav } from '@/components/navbar/MobileNav';

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/'); setOpen(false); };

  return (
    <header className="sticky top-0 z-50 bg-[#0A0A0A]/85 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
            <Wind className="w-7 h-7 text-[#00B4D8]" />
            <span className="font-display text-2xl">KITEIQ</span>
          </Link>

          <DesktopNav user={user} onLogout={handleLogout} />

          <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && <MobileNav user={user} onClose={() => setOpen(false)} onLogout={handleLogout} />}
    </header>
  );
};
